export default "__VITE_ASSET__BTAhfob6__"